import styled from 'styled-components'

export const FilePreview = styled.img`
  width: 24px;
  height: 24px;

  border-radius: 2px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    width: 32px;
    height: 32px;
  }
`
